import axios from "axios";
import React, { createContext } from "react";
import { useState, useEffect, useMemo } from "react";
import toast from "react-hot-toast";

export const GlobalVariablesContext = createContext(null);

function GlobalVariablesProvider(prop) {
  const [currentUser, setCurrentUser] = useState(null);
  // const [userData, setUserData] = useState(null);
  const [userData2, setUserData2] = useState(null);
  const [isLoggedIn2, setisLoggedIn2] = useState(localStorage.getItem("isLoggedIn2") || "false");
  // Shared rooms list for swipe navigation in mobile chat view
  const [rooms, setRooms] = useState([]);
  // Controls sidebar visibility on mobile (hidden when a chat is open)
  const [isMobileSidebarHidden, setIsMobileSidebarHidden] = useState(false);
  // Tracks which platform filter is active in the sidebar (needed by Chat.jsx for swipe nav)
  const [selectedPlatform, setSelectedPlatform] = useState('all');

  useEffect(() => {
    const fetchData = async () => {
      // setUserData(null);
      setUserData2(null);
      if (currentUser) {
        let num = null;

        if (currentUser.platform === 'instagram' || currentUser.platform === 'facebook') {
          try {
            const mapRes = await axios.get(`https://casualfootwears.com/api/id_mapping/?id=${currentUser.phone}`);
            if (mapRes.data && mapRes.data.number) {
              const mappedNum = mapRes.data.number;
              num = mappedNum.length >= 12 ? mappedNum.slice(2) : mappedNum;
            } else {
              console.warn('No mapped phone number found for this user');
            }
          } catch (error) {
            console.error("Error fetching ID mapping:", error);
          }
        } else {
          // WhatsApp logic
          num =
            currentUser.phone.length >= 12
              ? currentUser.phone.slice(2)
              : currentUser.phone;
        }

        if (num) {
          const amdesi = "https://www.amdesi.com/order_json/" + num + ".json";
          const ledshoe = "https://ledshoes.fun/master/order_json/" + num + ".json";

          // try {
          //   const amdesiRes = await axios.get(amdesi);
          //   if (amdesiRes.status === 200) {
          //     setUserData(amdesiRes.data);
          //   }
          // } catch (error) {
          //   console.log("Error while fetching AMDESI user data:: ", error);
          // }

          try {
            const ledshoeRes = await axios.get(ledshoe);
            if (ledshoeRes.status === 200) {
              setUserData2(ledshoeRes.data);
            }
          } catch (error) {
            console.error("Error fetching ledshoe data:", error);
          }
        }
      }
    };
    fetchData();
  }, [currentUser]);

  const logout = () => {
    localStorage.removeItem("isLoggedIn2");
    localStorage.removeItem("authToken");
    setisLoggedIn2("false");
  };

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const loginStatus = localStorage.getItem("isLoggedIn2");
    if (loginStatus === "true" && token) {
      setisLoggedIn2("true"); // Optimistic update
      axios.post("https://casualfootwears.com/api/verify-token/", { token: token })
        .then(response => {
          if (response.data.valid) {
            setisLoggedIn2("true");
          } else {
            logout();
          }
        })
        .catch(error => {
          console.error("Token verification failed:", error);
          logout();
        });
    } else {
      logout();
    }
  }, []);



  return (
    <GlobalVariablesContext.Provider
      value={{
        currentUser,
        setCurrentUser,
        userData2,
        isLoggedIn2,
        setisLoggedIn2,
        logout,
        rooms,
        setRooms,
        isMobileSidebarHidden,
        setIsMobileSidebarHidden,
        selectedPlatform,
        setSelectedPlatform,
      }}
    >
      {prop.children}
    </GlobalVariablesContext.Provider>
  );
}

export default GlobalVariablesProvider;
